const internalServerError = () => {
  window.location.href = '/internal-server-error';
};

export default internalServerError;
